export default __webpack_public_path__ + "static/media/user-at-desk.cbe54d94.png";